// core
import {Injectable} from '@angular/core';

// ngx-bootstrap
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';

// service
import {UserDataService} from './data.service';

// component
//import { ModalRelationComponent } from '../modal-relation/modal-relation.component';

// class
import {Model} from '../class/model';
import {Schema} from '../class/schema';

declare var jsPlumb: any;

@Injectable()
export class UserJsPlumbService {

    private _instance: any;
    private _instance1: any;
    private bsModalRef: BsModalRef;

    constructor(private dataService: UserDataService, private bsModalService: BsModalService) {
    }

    public init(): void {

        this._instance = jsPlumb.getInstance({
            Container: 'canvas',
            //Anchor: ['RightMiddle', 'LeftMiddle'],
            //Endpoint:["Dot",{radius:3}],
            //connector: ["Flowchart", { anchors: ["Bottom", "Top"] }],
            //Connector: ['Flowchart', {anchors: ['RightMiddle', 'LeftMiddle']}],
            //Connector: ['Bezier', {curviness: 50}],
            //Connector: ['Straight', {stub: 35, gap: 3}],
            Connector: ['Flowchart', {stub: 0, alwaysRespectStubs: false, gap: 3, midpoint: .5}],
            paintStyle: {strokeWidth: 3, stroke: 'blue'},
            //Connector: ['StateMachine', {margin: 5, curviness: 10, proximityLimit: 80}],
            layout: {
                type: 'Hierarchical'
            },
            ConnectionOverlays: [],
            Overlays: [['Arrow', {width: 8, length: 8, location: 1, foldback: 0.5, direction: 1}]],
            Anchors: ['Bottom', 'Top'],
            Endpoint: 'Blank',
            ConnectionsDetachable: false,
        });

        // this._instance1 = jsPlumb.getInstance({
        //     Container: 'canvas2',
        //     //Anchor: ['RightMiddle', 'LeftMiddle'],
        //     //Endpoint:["Dot",{radius:3}],
        //     //connector: ["Flowchart", { anchors: ["Bottom", "Top"] }],
        //     //Connector: ['Flowchart', {anchors: ['RightMiddle', 'LeftMiddle']}],
        //     //Connector: ['Bezier', {curviness: 50}],
        //     //Connector: ['Straight', {stub: 35, gap: 3}],
        //     Connector: ['Flowchart', {stub: 0, alwaysRespectStubs: false, gap: 3, midpoint: .5}],
        //     //Connector: ['StateMachine', {margin: 5, curviness: 10, proximityLimit: 80}],
        //     layout: {
        //         type: 'Hierarchical'
        //     },
        //     ConnectionOverlays: [],
        //     Overlays: [['Arrow', {width: 10, length: 10, location: 1, foldback: 0.5, direction: 1}]],
        //     Endpoint: 'Blank',
        //     Anchors: ['Bottom', 'Top'],
        //     ConnectionsDetachable: false,
        // });
    }

    getSortOrder(prop) {
        return function (a, b) {
            if (a[prop] < b[prop]) {
                return 1;
            } else if (a[prop] > b[prop]) {
                return -1;
            }
            return 0;
        };
    }

    public initModel(model: Model): void {
        // draggable
        this._instance.draggable(model.getElementId());
        this._instance.toggleDraggable(model.getElementId());

        if (model.belongsTo !== '') {
            if (model.parentRole !== '') {
                let models = this.dataService.getModelsByName(model.belongsTo);
                let filteredModels = [];
                filteredModels = models.filter((v, i) => v.type === model.parentRole);
                // console.log(filteredModels);
                filteredModels.sort(this.getSortOrder('id'));
                    this.createConnection(filteredModels[0], model);

            } else {
                let filtered_models = this.dataService.getModelsByName(model.belongsTo);
                filtered_models.sort(this.getSortOrder('id'));
                this.createConnection(filtered_models[0], model);
            }

        }

        // add endpoint
        if (model.is_pivot === false) {
            this._instance.addEndpoint(model.getElementH2Id(), {
                isSource: true,
                isTarget: true,
                cssClass: 'model-default-endpoint',
                beforeDrop: (params) => {
                    // this.bsModalRef = this.bsModalService.show(ModalRelationComponent, {
                    //     initialState: {
                    //         source_model: this.dataService.data.getModelByElementH2Id(params.sourceId),
                    //         target_model: this.dataService.data.getModelByElementH2Id(params.targetId)
                    //     }
                    // });
                    return false;
                },
            });
        }

        // load jsplumb connection
        for (let i = 0; i < this.dataService.data.models.length; i++) {
            for (let j = 0; j < this.dataService.data.models[i].schemas.length; j++) {
                this.initSchema(this.dataService.data.models[i].schemas[j]);
            }
        }
    }

    public initPreviewBlock(id) {
        this._instance1.draggable(id);
        this._instance1.toggleDraggable(id);
    }

    public createConnection(sourceModel: Model, targetModel: Model) {
        this._instance.connect({
            source: sourceModel.getElementH2Id(),
            target: targetModel.getElementH2Id(),
            paintStyle: {stroke: 'black', strokeWidth: 1},
            anchors: ['Bottom', 'Top']
        });
    }

    public destroyModel(model: Model) {
        // delete myself endpoint
        this._instance.selectEndpoints({
            source: model.getElementH2Id()
        }).delete();

        // check connection exists as destroy-model source

        // const parentConnections = this._instance.getConnections({
        //     target: model.getElementH2Id()
        // });
        // for (const connection of parentConnections) {
        //     jsPlumb.detach(connection);
        // }

        // var connections_to_delete = this._instance.getConnections({
        //     source: model.getElementH2Id()
        // });
        //
        // // source: this.dataService.data.getModelByName(model.belongsTo).getElementH2Id()
        // if (model.belongsTo !== '') {
        //     const parentConnections = this._instance.getConnections({
        //         target: model.getElementH2Id()
        //     });
        //     jsPlumb.deleteConnection(parentConnections[0]);
        // if (parentConnections[0]) {
        //     const conns = this._instance.getConnections({
        //         source: parentConnections[0].sourceId
        //     });
        //     for (const con of conns) {
        //         jsPlumb.deleteConnection(con);
        //     }
        //}
        //console.log(parentConnections[0]);


        //}
        const con = this._instance.getConnections({
            target: model.getElementH2Id()
        });
        jsPlumb.deleteConnection(con[0]);
        jsPlumb.remove(model.getElementId());
        //this.dataService.deleteModel(model.id);


        // for (let i = 0; i < connections_to_delete.length; i++) {
        //     var schema_to_delete = this.dataService.data.getSchemaByElementId(connections_to_delete[i].targetId);
        //     if (schema_to_delete) {
        //         this.dataService.deleteSchema(schema_to_delete);
        //     }
        // }
    }

    removeElement(model: Model) {
        const parentConnections = this._instance.getConnections({
            source: model.getElementH2Id()
        });
        for (const connection of parentConnections) {
            jsPlumb.detach(connection);
        }

        jsPlumb.remove(model.getElementId());
    }

    revalidate(id) {
        jsPlumb.recalculateOffsets(id);
    }

    public initSchema(schema: Schema) {


        if (schema.belongsto) {

            var source_id = this.dataService.data.getModelByName(schema.belongsto).getElementH2Id();
            var target_id = schema.getElementId();
            var option = {
                source: source_id,
                target: target_id
            };
            if (this._instance.getConnections(option).length === 0) {
                this._instance.connect(option);
            } else {
            }
        }
        this.dataService.flg_repaint = true;
    }

    public destroySchema(schema: Schema) {


        if (schema.belongsto) {
            var option = {
                target: schema.getElementId()
            };
            var connections_to_delete = this._instance.getConnections(option);
            for (let i = 0; i < connections_to_delete.length; i++) {
                this._instance.deleteConnection(connections_to_delete[i]);
            }
        }
    }

    public toggleDraggable(model: Model): void {
        this._instance.toggleDraggable(model.getElementId());
    }

    toggleDraggableDiv(id) {
        // this._instance.draggable(id);
        // //this._instance.toggleDraggable(model.getElementId());
        // this._instance.toggleDraggable(id);
        this._instance.toggleDraggable(id);
    }

    public addToDragSelection(obj) {
        this._instance.addToDragSelection(obj);
    }

    public clearDragSelection() {
        this._instance.clearDragSelection();
    }

    public repaintEverything(): void {
        this._instance.repaintEverything();
    }

    public deleteAll(): void {

        this._instance.deleteEveryEndpoint();
    }

    public getAllConnections(model: Model) {
        let targetIds = [];
        let conns = this._instance.getConnections({
            source: model.getElementH2Id()
        });
        for (const conn of conns) {
            //conn.setVisible(false);
            targetIds.push(conn.targetId);
        }
        return targetIds;
    }


    public toggleConnectionsVisibilityForNode(model: Model, status) {
        let conns = this._instance.getConnections({
            source: model.getElementH2Id()
        });
        for (const con of conns) {
            if (status === 'hide') {
                con.setVisible(false);
            } else if (status === 'show') {
                con.setVisible(true);
            }

        }

        return conns;
    }

    clearCanvas() {
        for (const model of this.dataService.data.models) {
            const conns = this._instance.getAllConnections(model);
            for (const con of conns) {
                this._instance.deleteConnection(con);
            }

        }
        this.dataService.data.models = [];
    }

    deleteModel(model: Model) {
        const conns = this._instance.getConnections({
            target: model.getElementH2Id()
        });
        for (const con of conns) {
            this._instance.deleteConnection(con);
        }
        this.dataService.deleteModel(model.id);
    }

    getWholeConnections() {
        return this._instance.getConnections_();
    }
}
